import { STOPrintPDFTypeEnum } from 'commons/enums';
import { ICompanyInfo, STODocument } from 'commons/types';
import { STO_PRINT_TEMPLATE_ROUTES } from 'routes/constants';
import { swiperxWmsApiDashboard } from 'services/apis/SwipeRxWmsApiDashboard';

import { mapSTOInvoicePrintData } from './STOInvoicePrintDataMapper.util';
import { mapSTOSuratPesananPrintData } from './STOSuratPesananPrintDataMapper.util';

const STORAGE_KEY: Record<STOPrintPDFTypeEnum, string> = {
  [STOPrintPDFTypeEnum.SURAT_PESANAN]: 'sto-surat-pesanan',
  [STOPrintPDFTypeEnum.INVOICE]: 'sto-invoice',
};

const _getPrintURL = (type: STOPrintPDFTypeEnum) => {
  switch (type) {
    case STOPrintPDFTypeEnum.SURAT_PESANAN:
      return `${STO_PRINT_TEMPLATE_ROUTES.SURAT_PESANAN}?&skip-alert-notif=true`;
    case STOPrintPDFTypeEnum.INVOICE:
      return `${STO_PRINT_TEMPLATE_ROUTES.INVOICE}?&skip-alert-notif=true`;
    default:
      return '/';
  }
};

export const stoPrintPDF = async (
  stoDocument: STODocument,
  fromWarehouse: ICompanyInfo,
  toWarehouse: ICompanyInfo,
  type: STOPrintPDFTypeEnum,
) => {
  // data may be large, so we store the already-mapped print data
  // temporarily in local storage, removed upon iframe destroyed
  const items = await swiperxWmsApiDashboard.getSTOItemList(
    stoDocument.sto_number,
  );
  const documentWithItems = { ...stoDocument, items };

  const mappedData =
    type === STOPrintPDFTypeEnum.INVOICE
      ? mapSTOInvoicePrintData(documentWithItems, fromWarehouse, toWarehouse)
      : mapSTOSuratPesananPrintData(
          documentWithItems,
          fromWarehouse,
          toWarehouse,
        );
  localStorage.setItem(STORAGE_KEY[type], JSON.stringify(mappedData));

  // trigger print
  const printedArea = document.createElement('iframe');
  printedArea.src = _getPrintURL(type);
  printedArea.hidden = true;
  document.body.appendChild(printedArea);

  const storageKey = STORAGE_KEY[type];

  printedArea.addEventListener('load', () => {
    setTimeout(() => {
      const printedContentWindow =
        printedArea.contentDocument || printedArea.contentWindow?.document;

      const anchorName =
        type === STOPrintPDFTypeEnum.SURAT_PESANAN ? '#inv-sign' : 'img';
      const anchorImg: HTMLImageElement | null | undefined =
        printedContentWindow?.querySelector(anchorName);
      if (anchorImg) {
        if (anchorImg.complete) {
          printedArea?.contentWindow?.focus();
          printedArea?.contentWindow?.print();
          setTimeout(() => {
            document.body.removeChild(printedArea);
            localStorage.removeItem(storageKey);
          }, 2000);
        } else {
          anchorImg.addEventListener('load', () => {
            printedArea?.contentWindow?.focus();
            printedArea?.contentWindow?.print();
            setTimeout(() => {
              document.body.removeChild(printedArea);
              localStorage.removeItem(storageKey);
            }, 2000);
          });
        }
      }
    }, 1000);
  });
};
